import React from "react";
import { Plane } from "lucide-react";

/**
 * TravelBio wordmark — "Travel" white serif + "Bio" gold script with a small
 * gold plane and a trail curving under the word "Bio".
 */
const SIZES = {
  sm: { travel: 22, bio: 28, plane: 10, gap: 3 },
  md: { travel: 36, bio: 46, plane: 14, gap: 4 },
  lg: { travel: 52, bio: 68, plane: 20, gap: 6 },
  xl: { travel: 64, bio: 84, plane: 24, gap: 8 },
};

export default function BrandLogo({
  size = "md",
  theme = "navy",
  className = "",
}) {
  const s = SIZES[size] || SIZES.md;
  const travelColor = theme === "navy" ? "#ffffff" : "#1a3a5f";
  const gold = "#e6b84a";

  return (
    <div className={`inline-block leading-none ${className}`} aria-label="TravelBio">
      <div
        className="inline-flex items-baseline leading-none"
        style={{ gap: s.gap }}
      >
        <span
          style={{
            fontFamily: '"Playfair Display", serif',
            fontWeight: 400,
            fontSize: s.travel,
            color: travelColor,
            letterSpacing: "0.005em",
            lineHeight: 1,
          }}
        >
          Travel
        </span>

        <span className="relative inline-block" style={{ lineHeight: 1 }}>
          <span
            style={{
              fontFamily: '"Allura", cursive',
              fontWeight: 400,
              fontSize: s.bio,
              color: gold,
              lineHeight: 0.82,
              display: "inline-block",
              transform: `translateY(${s.bio * 0.04}px)`,
            }}
          >
            Bio
          </span>

          {/* Trail under "Bio" + plane on the right end */}
          <span
            aria-hidden="true"
            className="pointer-events-none absolute"
            style={{
              left: s.bio * 0.05,
              right: -s.plane * 0.9,
              bottom: -s.bio * 0.18,
              height: s.bio * 0.35,
            }}
          >
            <svg
              viewBox="0 0 100 30"
              width="100%"
              height="100%"
              preserveAspectRatio="none"
              style={{ overflow: "visible", display: "block" }}
            >
              <path
                d="M 2 18 Q 28 28, 55 20 T 95 6"
                fill="none"
                stroke={gold}
                strokeWidth="1.6"
                strokeLinecap="round"
                opacity="0.95"
              />
            </svg>

            <Plane
              style={{
                position: "absolute",
                right: 0,
                top: -s.plane * 0.35,
                width: s.plane,
                height: s.plane,
                color: gold,
                transform: "rotate(-30deg)",
              }}
              strokeWidth={1.8}
              fill={gold}
            />
          </span>
        </span>
      </div>
    </div>
  );
}
